import type { Currency } from '@packages/domain/models/currency';
import { CURRENCIES_FROM_WITH_REWARDS } from 'constants/rewards';
import { currencyLookup } from 'hooks/useCurrencies/currencyLookup';
import isEmpty from 'lodash/isEmpty';
import type { RewardsAgreedTransaction } from 'models/rewards';
import type { RootState } from 'reducers/types';
import {
  isEmbedded,
  isRecurringOfferSelected,
  isRepeatingPayment,
} from 'selectors/ui';
import { isLoggedIn } from '../authentication';
import { getRepeatPaymentOffer } from '../offers';
import { getOrderPriceCurrency } from '../order';
import { getPaymentPriceCurrency } from '../payment';

export const getAgreedTransactionAmount = (state: RootState) => {
  const agreedTransaction = getAgreedTransactionObject(state);

  if (isEmpty(agreedTransaction)) {
    return 0;
  }

  return agreedTransaction.amount;
};

export const getAgreedTransactionCurrencyObject = (state: RootState) => {
  const agreedTransaction = getAgreedTransactionObject(state);
  if (agreedTransaction?.currency) {
    return currencyLookup.byCode(agreedTransaction.currency);
  }

  return {} as Currency;
};

const getAgreedTransactionObject = (
  state: RootState,
): RewardsAgreedTransaction | undefined => {
  const {
    entities: { rewards: { agreedTransaction } = {} },
  } = state;

  return agreedTransaction;
};

export const shouldShowRewardsForOrder = (state: RootState) => {
  const currencyFrom = getCurrencyFromOrder(state);
  const isSupportedCurrency =
    CURRENCIES_FROM_WITH_REWARDS.includes(currencyFrom);

  return isSupportedCurrency && !isEmbedded(state);
};

const getCurrencyFromOrder = (state: RootState): string => {
  if (isRepeatingPayment(state)) {
    const offer = getRepeatPaymentOffer(state);
    return offer?.price?.currency?.code ?? '';
  }

  return getOrderPriceCurrency(state);
};

export const shouldShowRewardsForPayment = (state: RootState) => {
  const currencyFrom = getPaymentPriceCurrency(state);

  const shouldShowRewards = CURRENCIES_FROM_WITH_REWARDS.includes(currencyFrom);

  return shouldShowRewards && !isEmbedded(state);
};

export const shouldShowRedeemRewards = (state: RootState) => {
  return (
    shouldShowRewardsForOrder(state) &&
    isLoggedIn(state) &&
    !isRecurringOfferSelected(state)
  );
};
